const HOMEPAGE = "/";
const TERMS = "/terms-and-conditions";

export { HOMEPAGE, TERMS };
